import {
  COMPTE_POIDS_LOAD_REQUEST,
  COMPTE_POIDS_LOAD_SUCCESS,
  COMPTE_POIDS_LOAD_FAILURE,
  COMPTE_POIDS_SET_FILTER,
  COMPTE_POIDS_SET_DATE_RANGE,
  COMPTE_POIDS_CREATE_ENTREE_BROUTILLE_REQUEST,
  COMPTE_POIDS_CREATE_ENTREE_BROUTILLE_SUCCESS,
  COMPTE_POIDS_CREATE_ENTREE_BROUTILLE_FAILURE,
  COMPTE_POIDS_CREATE_RETOUR_AVOIR_REQUEST,
  COMPTE_POIDS_CREATE_RETOUR_AVOIR_SUCCESS,
  COMPTE_POIDS_CREATE_RETOUR_AVOIR_FAILURE,
  COMPTE_POIDS_CLEAR_ERROR
} from '../actions/action-types';

const initialState = {
  items: [],
  totalSolde750: 0,
  loading: false,
  posting: false,
  error: null,
  filterClientId: null,
  dateDebut: null,
  dateFin: null,
  lastUpdated: null
};

export default function comptePoidsReducer(state = initialState, action) {
  switch (action.type) {
    case COMPTE_POIDS_LOAD_REQUEST:
      return { ...state, loading: true, error: null };
    case COMPTE_POIDS_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        items: action.payload?.items || [],
        totalSolde750: action.payload?.totalSolde750 || 0,
        lastUpdated: Date.now()
      };
    case COMPTE_POIDS_LOAD_FAILURE:
      return { ...state, loading: false, error: action.error || 'Erreur de chargement' };
    case COMPTE_POIDS_SET_FILTER:
      return { ...state, filterClientId: action.payload || null };
    case COMPTE_POIDS_SET_DATE_RANGE:
      return { ...state, dateDebut: action.payload.dateDebut, dateFin: action.payload.dateFin };
    case COMPTE_POIDS_CREATE_ENTREE_BROUTILLE_REQUEST:
    case COMPTE_POIDS_CREATE_RETOUR_AVOIR_REQUEST:
      return { ...state, posting: true, error: null };
    case COMPTE_POIDS_CREATE_ENTREE_BROUTILLE_SUCCESS:
    case COMPTE_POIDS_CREATE_RETOUR_AVOIR_SUCCESS:
      return {
        ...state,
        posting: false,
        error: null,
        items: action.payload?.items || [],
        totalSolde750: action.payload?.totalSolde750 || 0,
        lastUpdated: Date.now()
      };
    case COMPTE_POIDS_CREATE_ENTREE_BROUTILLE_FAILURE:
    case COMPTE_POIDS_CREATE_RETOUR_AVOIR_FAILURE:
      return { ...state, posting: false, error: action.error || 'Erreur de saisie' };
    case COMPTE_POIDS_CLEAR_ERROR:
      return { ...state, error: null };
    default:
      return state;
  }
}
